import { render } from "./FullSliderVue.vue?vue&type=template&id=4d98d5b4&ts=true"
import script from "./FullSliderVue.vue?vue&type=script&lang=ts"
export * from "./FullSliderVue.vue?vue&type=script&lang=ts"

import "./FullSliderVue.vue?vue&type=style&index=0&id=4d98d5b4&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__